module.exports = __webpack_public_path__ + "static/media/29ADMSPC15.fe3206e4.jpg";